<div class="full-page w-100 d-md-flex d-block px-0">
  <!--Left Side-->
  <div
    class="left-side-login"
    [style.background-image]="'url(' + ('login-registration/login-background.png' | contentAssetImage) + ')'"
  >
    <img class="shared-login-banner mb-4" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />
    <div class="content d-flex flex-column justify-content-center mt-5 py-3 px-5 bg-white rounded">
      <span
        class="material-symbols-outlined mb-3 text-center font-primary text-primary"
        [class.corporate-primary-color]="isCorporate"
      >
        engineering
      </span>
      <div class="text-container d-flex flex-column align-items-center">
        <h5 class="text-center maintenance-title font-primary font-size-22" [class.corporate-primary-color]="isCorporate">
          {{ 'maintenancepage.currentlyunavailable.title' | translate }}
        </h5>
        <div
          class="text-center maintenance-description font-size-14"
          [innerHTML]="'maintenancepage.currentlyunavailable.description' | translate | markdownTranslate"
        ></div>
      </div>
    </div>
  </div>
</div>
